import { SearchIcon } from '@chakra-ui/icons';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const TransferTableSearchBar = ({
    onSearch,
    query,
    isDisabled = false,
    placeholder = '',
    captionName = '',
}) => {
    const { darkMode } = useSelector((state) => {
        return { ...state.settings };
    });
    return (
        <InputGroup>
            <InputLeftElement>
                <SearchIcon />
            </InputLeftElement>
            <Input
                color={darkMode ? 'dark.textDark' : null}
                background={darkMode ? 'dark.bgDark' : null}
                borderColor={darkMode ? 'dark.tcap-borderGray' : null}
                data-walkthroughid={
                    '/service-profiles/input/search/' + captionName
                }
                type="text"
                placeholder={placeholder}
                isDisabled={isDisabled}
                onChange={(e) => {
                    const value = e.target.value;
                    onSearch(value);
                }}
                value={query}
            />
        </InputGroup>
    );
};

export default TransferTableSearchBar;
